import { defineMessages } from 'react-intl';

export default defineMessages({
  active: 'Active',
  invited: 'Invited',
  blocked: 'Blocked',
  pending: 'Pending',
  archived: 'Archived',
  deprecated: 'Deprecated',
  finished: 'Finished',
  inactive: 'Inactive',
  cancelled: 'Cancelled',
  replaced: 'Replaced',
  ending: 'Ending',
  upcoming: 'Upcoming',
  paid: 'Paid',
  refunded: 'Refunded',
  failed: 'Failed',
  invoice: 'Invoice',
  ended: 'Ended',
  running: 'Running',
  completed: 'Completed',
  reached_limit: 'Reached limit',
  estimated_reached_limit: 'May reach limit',
  exceeded_limit: 'Exceeded limit',
  estimated_exceeded_limit: 'May exceed limit',
  ok: 'Ok',
  skipped: 'Skipped',
  broken: 'Broken',
});
